import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your Firebase project config (from Firebase Console > Project Settings > Web App)
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDnI86WMWDUU4bJcpqCnTN-5lnY_BSB1mw",
  authDomain: "devotional-app-2025.firebaseapp.com",
  projectId: "devotional-app-2025",
  storageBucket: "devotional-app-2025.firebasestorage.app",
  messagingSenderId: "1060611168257",
  appId: "1:1060611168257:web:ee74587ee95af3a7288800"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
